import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { contratoAssessorSendAnaliseOperacional } from '../../store/modules/ContratosAssessoresActions';
import { closeModal } from '../../store/modules/ModalActions';
import { getElementID } from '../../utils/HTMLUtils';
import {
  ANALISE_OPERACIONAL_JUSTIFICATIVA_LENGTH,
  requiredIsValid,
} from '../../utils/ValidationUtils';
import { Col } from '../Col';
import { CustomButton } from '../CustomButton';
import { CustomTextArea } from '../CustomTextArea';
import CustomUploadButton from '../CustomUploadButton/CustomUploadButton';
import { GenericModal } from '../GenericModal';
import CloudUploadIcon from '../Icons/CloudUploadIcon';
import DeleteForeverIcon from '../Icons/DeleteForeverIcon';
import RefreshIcon from '../Icons/RefreshIcon';
import SaveIcon from '../Icons/SaveIcon';
import { Row } from '../Row';
import styles from './AnaliseOperacionalModal.scss';
import { uploadNaoAssinadoPlanoTrabalhoEntePublico } from '../../store/modules/ContratosEntePublicoActions';

const rootClassName = styles.rootClassName;
const rootElementId = 'contrato-analise-operacional-modal';

const INITIAL_STATE = {
  textChanged: false,
  text: '',
  file: null,
  jobFile: null,
};

class AnaliseOperacionalModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE,
    };
  }

  getTitle = () => {
    return (
      <>
        {this.props.title}
        {this.props.loading ? (
          <RefreshIcon className={rootClassName + '-loading-icon'} />
        ) : null}
      </>
    );
  };

  getDescription = () => {
    return this.props.description ? (
      <Row className={rootClassName + '-description'}>
        <Col cols={[12, 12, 12, 12, 12]}>
          <small>{this.props.description}</small>
        </Col>
      </Row>
    ) : null;
  };

  textIsValid = () => {
    const required = requiredIsValid(
      this.state.text,
      this.props.languageValues.validations.justificativaAnaliseOperacional
        .required
    );
    if (!required.status) {
      return required;
    }
    return {
      status: true,
    };
  };

  toSubmit = () => {
    this.props.submitCallback(
      this.state.text,
      this.state.file,
      this.state.jobFile
    );
  };

  toClose = () => {
    this.props.closeModal(this.props.modalKey);
  };

  uploadFileIsEnabled = () => {
    return this.props.uploadFile &&
      typeof this.props.uploadFileValidation === 'function'
      ? true
      : false;
  };

  toUnselectFile = () => {
    this.setState({
      file: null,
    });
  };

  toUnselectJobFile = () => {
    this.setState({
      jobFile: null,
    });
  };

  onSelectedFile = (file) => {
    this.setState({
      file,
    });
  };

  onSelectedJobFile = (jobFile) => {
    this.setState({
      jobFile,
    });
  };

  render() {
    return (
      <GenericModal
        onClose={() => {
          this.toClose();
        }}
        title={this.getTitle()}
        sending
        footerContent={
          <Row>
            <Col cols={[12, 6, 6, 6, 6]}>
              <CustomButton
                theme='pufvYellow'
                className={rootClassName + '-cancel-button'}
                label={
                  this.props.cancelButtonLabel ||
                  this.props.languageValues.cancelButton
                }
                onClick={() => this.toClose()}
              />
            </Col>
            <Col cols={[12, 6, 6, 6, 6]}>
              <CustomButton
                theme='pufvYellow'
                className={rootClassName + '-save-buttom'}
                label={
                  this.props.submitButtonLabel ||
                  this.props.languageValues.enviar
                }
                disabled={this.props.loading || !this.textIsValid().status}
                rightIcon={<SaveIcon />}
                onClick={this.toSubmit}
                type='submit'
              />
            </Col>
          </Row>
        }
      >
        <>
          {this.getDescription()}
          <Row>
            <Col cols={[12, 12, 12, 12, 12]}>
              <CustomTextArea
                label={this.props.descriptionLabel}
                value={this.state.text}
                onChange={(event) => {
                  this.setState({
                    ...this.state,
                    textChanged: true,
                    text: event.target.value,
                  });
                }}
                helperText={
                  this.state.textChanged && !this.textIsValid().status
                    ? this.textIsValid().error
                    : ''
                }
                error={this.state.textChanged && !this.textIsValid().status}
                counter={true}
                disabled={this.props.loading}
                maxSize={ANALISE_OPERACIONAL_JUSTIFICATIVA_LENGTH}
              />
            </Col>
          </Row>
          {this.uploadFileIsEnabled() ? (
            <Row>
              <Col
                cols={[12, 12, 12, 12, 6]}
                className={rootClassName + '-upload-column'}
              >
                {this.state.file ? (
                  <CustomButton
                    id={getElementID(rootElementId, 'remove-upload-button')}
                    leftIcon={<DeleteForeverIcon />}
                    theme='error'
                    onClick={this.toUnselectFile}
                    counter={1}
                    tooltip={
                      this.props.languageValues
                        .cadastroContratoUnselectDocumentoHint
                    }
                    label={
                      this.props.languageValues
                        .cadastroContratoUnselectDocumentoLabelButton
                    }
                    disabled={this.props.loading}
                  />
                ) : (
                  <CustomUploadButton
                    id={getElementID(rootElementId, 'upload-button')}
                    label='Upload - Contrato'
                    buttonComponent={CustomButton}
                    buttonComponentProps={{
                      id: 'upload-contrato-' + this.props.idContrato,
                      label:
                        this.props.languageValues
                          .cadastroContratoSelectDocumentoLabelButton,
                      theme: 'pufvYellow',
                      leftIcon: <CloudUploadIcon />,
                      counter: this.state.file ? 1 : 0,
                      tooltip:
                        this.props.languageValues
                          .cadastroContratoSelectDocumentoHint,
                    }}
                    onChange={this.onSelectedFile}
                    fileIsValid={this.props.uploadFileValidation}
                    disabled={this.props.loading}
                  />
                )}
              </Col>
              <Col
                cols={[12, 12, 12, 12, 6]}
                className={rootClassName + '-upload-column'}
              >
                {this.state.jobFile ? (
                  <CustomButton
                    id={getElementID(rootElementId, 'remove-upload-button')}
                    leftIcon={<DeleteForeverIcon />}
                    theme='error'
                    onClick={this.toUnselectJobFile}
                    counter={1}
                    tooltip={
                      this.props.languageValues
                        .cadastroContratoUnselectDocumentoHint
                    }
                    label={
                      this.props.languageValues
                        .cadastroContratoUnselectDocumentoLabelButton
                    }
                    disabled={this.props.loading}
                  />
                ) : (
                  <CustomUploadButton
                    id={getElementID(rootElementId, 'upload-button')}
                    label='Upload - Plano de trabalho'
                    buttonComponent={CustomButton}
                    buttonComponentProps={{
                      id: 'upload-plano-de-trabalho-' + this.props.idContrato,
                      label:
                        this.props.languageValues
                          .cadastroContratoSelectDocumentoLabelButton,
                      theme: 'pufvYellow',
                      leftIcon: <CloudUploadIcon />,
                      counter: this.state.jobFile ? 1 : 0,
                      tooltip:
                        this.props.languageValues
                          .cadastroContratoSelectDocumentoHint,
                    }}
                    uploadAction={(jobFile) => {
                      this.onSelectedJobFile(jobFile);
                    }}
                    uploadActionData={{
                      versaoContrato: this.props.versaoContrato,
                      idContrato: this.props.idContrato,
                      flgFilePrincipal: true,
                    }}
                    disabled={this.props.loading}
                  />
                )}
              </Col>
            </Row>
          ) : null}
        </>
      </GenericModal>
    );
  }
}

AnaliseOperacionalModal.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  modalKey: PropTypes.string.isRequired,
  descriptionLabel: PropTypes.string.isRequired,
  cancelButtonLabel: PropTypes.string,
  submitButtonLabel: PropTypes.string,
  idContrato: PropTypes.string,
  versaoContrato: PropTypes.number,
  submitCallback: PropTypes.func.isRequired,
  savedCallback: PropTypes.func,
  uploadFile: PropTypes.bool,
  uploadFileValidation: PropTypes.func,
  loading: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  contratos: state.contratos,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      closeModal,
      uploadNaoAssinadoPlanoTrabalhoEntePublico,
      contratoAssessorSendAnaliseOperacional,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AnaliseOperacionalModal);
